export const MONTHLY_SALES_REQUEST = 'MONTHLY_SALES_REQUEST'
export const MONTHLY_SALES_SUCCESS = 'MONTHLY_SALES_SUCCESS'
export const MONTHLY_SALES_FAIL = 'MONTHLY_SALES_FAIL'

export const PRODUCT_SALES_REQUEST = 'PRODUCT_SALES_REQUEST'
export const PRODUCT_SALES_SUCCESS = 'PRODUCT_SALES_SUCCESS'
export const PRODUCT_SALES_FAIL = 'PRODUCT_SALES_FAIL'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'